import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { TruncatedTextWithTooltip } from "@similarweb/ui-components";

import { DetailsRow } from "./DetailsRow";
import { NaValue } from "./NaValue";

type ContentRowProps = {
    content: string | null | undefined;
};

export const ContentRow = ({ content }: ContentRowProps) => {
    const { translate } = useTranslate();

    return (
        <DetailsRow label={translate("activation.alerts.cards.social-post.modal.content")}>
            {content ? (
                <TruncatedTextWithTooltip
                    fontVariant="input2"
                    color={colorsPalettes.carbon[500]}
                    minWidth={0}
                    lineClamp={6}
                >
                    {content}
                </TruncatedTextWithTooltip>
            ) : (
                <NaValue />
            )}
        </DetailsRow>
    );
};
